<template>
    <BreadCrumb PageTitle="Ajouter une correction request" />
     <AddModalCorrectionRequest/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddModalCorrectionRequest from "@/components/CorrectionRequest/AddModalCorrectionRequest.vue";

  
    export default defineComponent({
      name: "AddCorrectionRequestPage",
      components: {
        BreadCrumb,
        AddModalCorrectionRequest,
      },
    });
  </script>